import { connect } from 'react-redux'

import MapWrapper, { IStateProps, IDispatchProps, IOwnProps } from './MapWrapper'
import { IStoreState } from '../../services/store/IStoreState'

function mapStateToProps(state: IStoreState): IStateProps {
  return {
    storeName: state.Dashboard.storeName,
    vehicle: state.Dashboard.vehicles[0],
  }
}

function mapDispatchToProps(): IDispatchProps {
  return {}
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(MapWrapper)